import { useQuery } from '@tanstack/vue-query';
import { computed, unref } from '@vue/composition-api';
import type { MaybeRef } from '@vueuse/core';
import { DashboardService } from '../../api/service/dashboard.service';
import type { DocumentStatsType } from '../../api/types/document-stats-type';
import { widgetKeys } from '../../api/widget-keys';

export const useDocumentStats = (showAll: MaybeRef<boolean>, type: DocumentStatsType) =>
  useQuery({
    queryKey: computed(() => widgetKeys.documentStatsDetail(unref(showAll), type)),
    queryFn: () => DashboardService.loadDocumentStatsByType(type, unref(showAll)),
  });
